/**
 * DataSheet Design Tokens
 * Extracted to separate file to avoid circular imports.
 */

export const dataSheetTokens = {
    // Spacing (8pt grid)
    spacing: {
        xxs: 4,
        xs: 8,
        sm: 12,
        md: 16,
        lg: 24,
    },
    // Colors
    colors: {
        background: '#FAFAFA',
        surface: '#FFFFFF',
        // Opaque colors for proper sticky column rendering
        headerBg: '#FAFAFA',
        headerBgSticky: '#F5F5F5', // Slightly darker for sticky headers
        surfaceSticky: '#FFFFFF', // Opaque white for sticky cells
        border: 'rgba(0, 0, 0, 0.06)',
        borderSubtle: 'rgba(0, 0, 0, 0.04)',
        borderStrong: 'rgba(0, 0, 0, 0.18)',
        textPrimary: 'rgb(26, 32, 44)',
        textSecondary: 'rgb(100, 116, 139)',
        textMuted: 'rgb(148, 163, 184)',
        activeTab: 'rgb(1, 149, 255)',
        hoverRow: 'rgba(0, 0, 0, 0.015)',
    },
    // Typography
    typography: {
        title: { fontSize: 14, fontWeight: 600, lineHeight: 1.4 },
        subtitle: { fontSize: 12, fontWeight: 400, lineHeight: 1.4 },
        header: {
            fontSize: 11,
            fontWeight: 600,
            textTransform: 'uppercase' as const,
            letterSpacing: '0.03em',
        },
        cell: { fontSize: 13, fontWeight: 400 },
        cellMono: { fontSize: 12, fontWeight: 400, fontFamily: 'monospace' },
    },
    // Dimensions
    dimensions: {
        headerBarHeight: 40,
        rowHeight: 46,
        tabHeight: 32,
        controlHeight: 28,
    },
} as const;

/**
 * Fallback width for a column that declares none. `table-layout: fixed` reads
 * `auto` as "split the container equally", which collapses wide tables into
 * unreadable slivers instead of overflowing into the horizontal scroller. A
 * concrete default keeps every column legible and lets the table grow past its
 * container, which is what makes the scrollbar appear.
 */
export const DEFAULT_COLUMN_WIDTH = 150;
